async function priceRings() {
  let parent = document.querySelector('.multy-slider');
  debugger
  if (!parent) return;

  let ranges = document.querySelectorAll('.multy-slider input[type=range]'),
    numbers = document.querySelectorAll('.multy-slider input[type=number]');

  function syncValues(src, dest) {
    let val1 = parseFloat(src[0].value),
      val2 = parseFloat(src[1].value);

    if (val1 > val2) {
      [val1, val2] = [val2, val1]; // Swap the values if they are in the wrong order
    }

    dest[0].value = val1;
    dest[1].value = val2;
  }

  ranges.forEach(function (range) {
    range.oninput = function () {
      syncValues(ranges, numbers);
    };
  });

  numbers.forEach(function (number) {
    number.oninput = function () {
      syncValues(numbers, ranges);
    };
  });
}
